import { HalalShopOrderFormValues } from '@pages/HalalShopOrderDetail/HalalShopOrderForm/types';

import { DeliveryRecord } from '@features/halalShop/store/types';
import { HalalShopCartItem } from './types';

export const halalShopCartItemMockList: HalalShopCartItem[] = [
  {
    id: 1,
    name: 'Японский зеленый порошковый чай матча Matsu, 20 г',
    cost: 3585,
    count: 4,
    photo: '',
  },
  {
    id: 2,
    name: 'Тестовый товар - Placeholder',
    cost: 2250,
    count: 1,
    photo: '',
  },
];

export const initHalalShopDetailOrderDeliveryValuesPlaceholder: DeliveryRecord =
  {
    name: '',
    price: { currency: '', value: 0 },
  };

export const initHalalShopDetailOrderValuesPlaceholder: HalalShopOrderFormValues =
  {
    street: '',
    apt: '',
    house: '',
    firstName: '',
    lastName: '',
    middleName: '',
    postCode: '',
    items: [],
    phone: '',
    email: '',
    postId: null,
  };
